import { render, staticRenderFns } from "./AwsAgreement.vue?vue&type=template&id=2d78d453&scoped=true&"
import script from "./AwsAgreement.vue?vue&type=script&lang=js&"
export * from "./AwsAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78d453",
  null
  
)

export default component.exports